import { resolveLeadDisplayName, type LeadDisplayNameInput } from "@/lib/lead-display-name";

const PREVIEW_MAX_LENGTH = 160;
const TITLE_MAX_LENGTH = 60;

/** Normaliza preview de mensagem para exibição em notificação push. */
export function normalizeNotificationPreview(raw: string | null | undefined): string {
  if (raw == null) return "";
  let text = raw.trim();
  if (!text) return "";

  if (text === "[Vídeo]" || text === "[Video]") text = "🎥 Vídeo";
  else if (text === "[Imagem]" || text === "[imagem]") text = "📷 Imagem";
  else if (text === "[Áudio]" || text === "[Audio]") text = "🎵 Áudio";
  else if (text === "[Documento]" || text === "[documento]") text = "📄 Documento";

  text = text.replace(/\s+/g, " ").trim();
  if (text.length > PREVIEW_MAX_LENGTH) {
    return text.slice(0, PREVIEW_MAX_LENGTH);
  }
  return text;
}

/** Título = nome do lead; corpo = preview (estilo WhatsApp). */
export function buildInboundMessageNotification(
  leadName: string,
  preview: string | null | undefined,
): { title: string; body: string } {
  const title = (leadName.trim() || "Contato").slice(0, TITLE_MAX_LENGTH);
  const body = normalizeNotificationPreview(preview) || "Mensagem";
  return { title, body };
}

/** Resolve nome amigável e monta notificação inbound. */
export function buildInboundMessageNotificationForLead(
  lead: LeadDisplayNameInput,
  preview: string | null | undefined,
): { title: string; body: string } {
  return buildInboundMessageNotification(resolveLeadDisplayName(lead), preview);
}
